import { useTranslation } from "react-i18next";

import { MarkdownContent } from "features/ui/MarkdownContent";

interface Props {
  content: string;
  name: string;
  onCollapse: () => void;
}

const ExpandedDirective = ({ content, name, onCollapse }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className="my-1 rounded border border-purple-200 bg-purple-50/50"
      data-testid={`duck-expanded-directive-${name}`}
    >
      <button
        aria-label={t("duck:directive_collapse", { name })}
        className="flex w-full items-center gap-1 rounded-t px-2 py-1 text-sm font-medium text-purple-900 hover:bg-purple-100"
        type="button"
        onClick={onCollapse}
      >
        /{name}
      </button>
      <div className="border-t border-purple-200 px-2 py-1">
        <MarkdownContent content={content} />
      </div>
    </div>
  );
};

export default ExpandedDirective;
